import React, { useEffect } from "react";
import Newnavigation from "../../components/new-navigation/new_navigation";
import PageBanner from "../../components/page-banner/page-banner";
import ContactNew from "../../components/contact-form/ContactNew";
import Footer from "../../components/footer/Footer";
import PageSmallBanner from "../../components/page-small-banner/page-small-banner";
import KeyServices from "../../components/key-services/KeyServices";
import OurMissions from "../../components/Our-missions/OurMissions";
import ComAccord from "../../components/Accordian/ComAccord";
import WhatweDo from "../../components/what-we-do-img/whatweDo";
import { HealthcareMissons, HealthcareAccord, HealthcareWhatwedo, KeyserviceHealthcare } from "../../utils/healthcare";
import { BG7, HEALTH_CARE_BG } from "../../assets/images/index";
import { motion } from "framer-motion";
import HeaderSeo from "../../components/HeaderSeo/Headerseo";
import { HealthCareSeo } from "../../utils/Seo";

const Healthcare = () => {
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
    >
    <div>
    <HeaderSeo data={HealthCareSeo}/>
      <Newnavigation routeName="Healthcare" />
      <PageBanner
        bg={HEALTH_CARE_BG}
        title="Transforming Healthcare with Techno Genesis"
        contact="Contact Us"
      />
      <WhatweDo data={HealthcareWhatwedo} />
      <OurMissions data={HealthcareMissons} />
      <KeyServices data={KeyserviceHealthcare} heading={"Healthcare Solutions"} />
      <div className="mt-100 mb-50">
        <PageSmallBanner
          isBtn={true}
          btn_text="Contact Us"
          title="Join The Revolution Driving Healthcare's Digital Future with Techno Genesis"
          bg={BG7}
          height="357px"
        />
      </div>
      <div className="mb-50">
        <ComAccord data={HealthcareAccord} />
      </div>
      <ContactNew />
      <Footer />
    </div>
    </motion.div>
  );
};
export default Healthcare;
